import {
  ADD_AD,
  ADD_AD_ERROR,
  ADD_AD_SUCCESS,
  DELETE_AD,
  DELETE_AD_ERROR,
  DELETE_AD_SUCCESS,
  GET_ADS,
  GET_ADS_ERROR,
  GET_ADS_SUCCESS,
  GET_AD,
  GET_AD_SUCCESS,
  UPDATE_AD,
  UPDATE_AD_ERROR,
  UPDATE_AD_SUCCESS,
  GET_ADS_SELECT_LIST,
  GET_ADS_SELECT_LIST_SUCCESS,
  GET_ADS_SELECT_LIST_ERROR,
  TOGGLE_AD_MODAL,
  UPLOAD_AD_BANNER,
  UPLOAD_AD_BANNER_SUCCESS,
  UPLOAD_AD_BANNER_ERROR,
} from "./actionTypes";

/**
 * get ads
 * @param {*} request
 * @returns
 */
export const getAds = (request) => {
  return {
    type: GET_ADS,
    payload: { request },
  };
};

export const getAdsSuccess = (paginatedAds) => {
  return {
    type: GET_ADS_SUCCESS,
    payload: paginatedAds,
  };
};

export const getAdsError = (message) => {
  return {
    type: GET_ADS_ERROR,
    payload: message,
  };
};

export const addAd = (request) => {
  return {
    type: ADD_AD,
    payload: { request },
  };
};

export const addAdSuccess = () => {
  return {
    type: ADD_AD_SUCCESS,
  };
};

export const addAdError = (error) => {
  return {
    type: ADD_AD_ERROR,
    payload: error,
  };
};

export const getAd = (id) => {
  return {
    type: GET_AD,
    payload: { id },
  };
};

export const getAdSuccess = (customer) => {
  return {
    type: GET_AD_SUCCESS,
    payload: customer,
  };
};

export const getAdError = (message) => {
  return {
    type: GET_ADS_ERROR,
    payload: message,
  };
};

export const updateAd = (request) => {
  return {
    type: UPDATE_AD,
    payload: { request },
  };
};

export const updateAdSuccess = () => {
  return {
    type: UPDATE_AD_SUCCESS,
  };
};

export const updateAdError = (error) => {
  return {
    type: UPDATE_AD_ERROR,
    payload: error,
  };
};

export const deleteAd = (id) => {
  return {
    type: DELETE_AD,
    payload: { id },
  };
};

export const deleteAdSuccess = () => {
  return {
    type: DELETE_AD_SUCCESS,
  };
};

export const deleteAdError = (error) => {
  return {
    type: DELETE_AD_ERROR,
    payload: error,
  };
};

export const uploadAdBanner = (banner, lang) => {
  return {
    type: UPLOAD_AD_BANNER,
    payload: { banner, lang },
  };
};

export const uploadAdBannerSuccess = (banner, lang) => {
  return {
    type: UPLOAD_AD_BANNER_SUCCESS,
    payload: { banner, lang },
  };
};

export const uploadAdBannerError = (error) => {
  return {
    type: UPLOAD_AD_BANNER_ERROR,
    payload: error,
  };
};

export const getAdsSelectList = () => {
  return {
    type: GET_ADS_SELECT_LIST,
  };
};

export const getAdsSelectListSuccess = (selectList) => {
  return {
    type: GET_ADS_SELECT_LIST_SUCCESS,
    payload: selectList,
  };
};

export const getAdsSelectListError = (error) => {
  return {
    type: GET_ADS_SELECT_LIST_ERROR,
    payload: error,
  };
};

export const toggleAdModalAction = () => {
  return {
    type: TOGGLE_AD_MODAL,
  };
};
